// extracted by mini-css-extract-plugin
module.exports = {"article":"article-module--article--1z3vD","content":"article-module--content--1gCC2","inner":"article-module--inner--f-skS"};